module.exports = __webpack_public_path__ + "img/nico-smit-PTv-B97DHNI-unsplash.8106bf0b.jpg";